(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEmailView', drvEmailView);

    drvEmailView.$inject = [];
    drvEmailViewCtrl.$inject = ['$filter', 'TagsService', 'DialogService'];
    
    /**
     * @ngdoc directive
     * @name drvEmailView
     * 
     * @description
     * Used for viewing email messages. Includes support for typical email properties including attachments.
     *
     * @param {object} email - The email which will be shown.
     * @param {bool} enableTagEditing - True to allow the user to edit tags. Default is false.
     */
    function drvEmailView() {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                email: '=',
                enableTagEditing: '<?'
            },
            controller: drvEmailViewCtrl,
            controllerAs: 'drvCtrl',
            bindToController: true,
            templateUrl: 'app/email/email-view.tmpl.html'
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }

    function drvEmailViewCtrl($filter, TagsService, DialogService) {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.showProperty = showProperty;
        drvCtrl.attachmentHandler = {
            viewAttachment: viewAttachment
        };
        Object.defineProperty(drvCtrl, 'date', {
            get: getFormattedDate
        });

        activate();

        function activate() {
            loadTags();
        }

        function showProperty(property) {
            var result = false;

            switch (property) {
                case 'Cc':
                    if (!_.isNil(drvCtrl.email.data.Cc) && drvCtrl.email.data.Cc !== '' && drvCtrl.email.data.Cc.length > 0) {
                        result = true;
                    }
                    break;
                case 'Bcc':
                    if (!_.isNil(drvCtrl.email.data.Bcc) && drvCtrl.email.data.Bcc !== '' && drvCtrl.email.data.Bcc.length > 0) {
                        result = true;
                    }
                    break;
                case 'ReplyTo':
                    if (!_.isNil(drvCtrl.email.data.ReplyTo) && drvCtrl.email.data.ReplyTo !== '' && drvCtrl.email.data.ReplyTo.length > 0) {
                        result = true;
                    }
                    break;
                case 'Preheader':
                    if (!_.isNil(drvCtrl.email.data.Preheader) && drvCtrl.email.data.Preheader !== '') {
                        result = true;
                    }
                    break;
            }

            return result;
        }

        /**
         * @returns {promise} view attachment using the supplied file details.
         */
        function viewAttachment(file) {
            return drvCtrl.email.viewAttachment(file);
        }

        /**
         * @returns {string} date formatted into a more readible form
         */
        function getFormattedDate() {
            // TODO: Due to lack of field formatting, $filter is being used to convert the date into a more readable string. Once proper formatting is introduced this code should be updated
            // to reflect the new functionality.
            var result = '';

            if (angular.isDefined(drvCtrl.email)) {
                result = $filter('date')(drvCtrl.email.data.Date, "longDate") + ' ' + $filter('date')(drvCtrl.email.data.Date, "shortTime");
            }

            return result;
        }

        /**
         * Load tags into the drvCtrl.tags variable.
         *
         * @returns {promise} A promise that resolves once the tags are loaded, or an error occurred.
         */
        function loadTags() {
            return TagsService.query({ tagUsage: 'Email' })
                .then(getTagsOk, getTagsError);

            function getTagsOk(data) {
                drvCtrl.tags = data.Tags;
            }

            function getTagsError(response) {
                DialogService.error('Error fetching Tags', response);
            }
        }
    }
})();
